var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status !== 'none')?_c('div',{staticClass:"preview_menu_banner",class:_vm.classes,attrs:{"data-state":_vm.status,"role":"status","aria-live":"polite"}},[_vm._v(_vm._s(_vm.text))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }